import { IAppState } from '../../redux';
import { EPlacingType, IPublishOption } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export const selectActiveOption = (state: IAppState): IPublishOption | null => {
  const service = selectActiveService(state);

  if (!service) {
    return null;
  }

  const {
    publishOptions: { packages, selectedPackageId, periods, selectedPeriodId, selectedPlacingType },
  } = service;

  if (selectedPlacingType === EPlacingType.package && selectedPackageId) {
    return packages[selectedPackageId];
  }

  if (selectedPlacingType === EPlacingType.balance && selectedPeriodId) {
    return periods[selectedPeriodId];
  }

  return null;
};
